import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { StandardContainer } from "../common"

const StyledBlogPager = styled(StandardContainer)`
  display: flex;
  justify-content: space-between;
  margin: 4rem auto;
  color: #005d73;

  > a {
    font-weight: 700;
  }
  > div {
    font-weight: 700;
  }
`

export const BlogPager = ({ pageContext }) => {
  const { previousPagePath, nextPagePath, numberOfPages, humanPageNumber } =
    pageContext
  return (
    <StyledBlogPager $wrappedStandard>
      {previousPagePath && <Link to={previousPagePath}>&lsaquo; Previous</Link>}
      {!previousPagePath && <span />}
      {numberOfPages > 1 && (
        <div>
          {numberOfPages} of {humanPageNumber}
        </div>
      )}
      {!nextPagePath && <span />}
      {nextPagePath && <Link to={nextPagePath}>Next &rsaquo;</Link>}
    </StyledBlogPager>
  )
}
